import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface BillingProvider {
    entityType: string;
    organizationName: string;
    firstName: string;
    lastName: string;
    middleName: string;
    identityInformation: {
        IDType1: string;
        IDNumber1: number;
        IDType2: string;
        IDNumber2: number;
        medicaidProviderNumber: number;
        NPINumber: number;
        providerCommercialNumber: number;
        additionalProviderNumber: number;
        demonstrationProjectIdentifier: string;
    },
    providerAddress: {
        st1: string;
        st2: string;
        city: string;
        state: string;
        country: string;
        phoneNumber: number;
        zipCode: number;
        accuracy: number;
    },
    contactInformation: {
        name: string;
        email: string;
    },
    financialRouting: {
        accountNumber: number;
        bankCode: number;
    }
}

export const getBillingProvider = createAsyncThunk(
    'billingProvider/get/',
    async ({ page, pageSize, sortBy, sortDir, searchTerm  }: { page: number, pageSize: number, sortBy: string, sortDir: string, searchTerm: string }) => {
        try {
            if (page && pageSize) {
                const response = await axios.get(`billingProvider/get?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchTerm=${searchTerm}`)
                return {
                    data: response.data
                }
            } else {
                const response = await axios.get('billingProvider/get')
                return {
                    data: response.data
                }
            }

        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const getOneBillingProvider = createAsyncThunk(
    'billingProvider/getOne/',
    async (id: string | undefined) => {
        try {
            const response = await axios.get('billingProvider/getOne/' + id)
            return {
                data: response.data
            }
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const addBillingProvider = createAsyncThunk(
    'billingProvider/create',
    async (data: BillingProvider) => {
        try {
            const response = await axios.post('billingProvider/create', data)
            return response.data
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)

export const deleteBillingProvider = createAsyncThunk(
    'billingProvider/delete/',
    async (data: string) => {
        try {
            const response = await axios.delete('billingProvider/delete/' + data)
            return response.data
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)


export const updateBillingProvider = createAsyncThunk(
    'billingProvider/update',
    async (data: BillingProvider) => {
        try {
            const response = await axios.put('billingProvider/update', data)
            return response.data
        }
        catch (err) {
            console.log(err)
            return err
        }
    }
)